import classNames from 'classnames'

import { type IServiceDec } from '@App/types/servicesTypes'

import style from './CategoriesForChose.module.scss'

interface IProps {
    sections: IServiceDec[]
    category: IServiceDec | null
    setCategory: (category: IServiceDec | null) => void
    setChosen: (chosen: IServiceDec | null) => void
}

export const CategoriesForChose = (props: IProps) => {
    const { sections, setCategory, category, setChosen } = props
    return (
        <div className={style.container}>
            <div className={style.categoriesTitles}>
                {sections.map((section) => {
                    const { id, name } = section
                    const cn = classNames(style.title, category && id === category.id && style.chosenTitle)
                    const onClickHandler = () => {
                        setChosen(null)
                        setCategory(section)
                    }
                    return (
                        <div key={id} className={cn} onClick={onClickHandler}>
                            <span>{name}</span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
